import { arcadeApiClient } from '../../../apiClients';
import { AppContext } from '../../../providers';
import { useContext, useEffect, useState } from 'react';
import { CbTooltip } from '../CbTooltip';
import { ICON_BY_NAME } from '../Icons/Icon';
export const CbNotificationToggle = ({
  userID,
  teamID,
  value
}: {
  userID: number;
  teamID: number;
  value?: boolean;
}) => {
  const {
    setToast
  } = useContext(AppContext);

  // This pattern sucks, but: if we change it locally, display that change locally; if the value changes from above, that overrides the local value.
  const [localValue, setValue] = useState(value);
  useEffect(() => {
    setValue(value);
  }, [value]);
  const onChange = async (notificationsEnabled: boolean): Promise<void> => {
    const endpointUrl = `/multi_platform/manage/teams/${teamID}/toggle_notifications`;
    try {
      await arcadeApiClient.put(endpointUrl, {
        user_id: userID,
        notifications_enabled: notificationsEnabled
      });
      setToast?.({
        status: 'success',
        description: 'Team notifications have been changed.'
      });
      setValue(notificationsEnabled);
    } catch (err) {
      console.error('Transaction archive Error: ', err);
      setToast?.({
        status: 'error',
        description: 'Error: Unable to update notification settings.'
      });
    }
  };
  if (localValue === true) {
    return <CbTooltip content="Notifications involving this learner will be sent to this team">
        <button type="button" onClick={() => onChange(false)} data-testid={`disable-${userID}-${teamID}`}>
          <ICON_BY_NAME.alarmbell width="15px" height="15px" color="chonky.500" />
        </button>
      </CbTooltip>;
  } else if (localValue === false) {
    return <CbTooltip content="Notifications involving this learner will not be sent to this team">
        <button type="button" onClick={() => onChange(true)} data-testid={`enable-${userID}-${teamID}`}>
          <ICON_BY_NAME.alarmbelloff width="15px" height="15px" color="chonky.500" />
        </button>
      </CbTooltip>;
  } else {
    // When a player is added to a team, but not saved yet, show that they *will* get notifications, but don't allow toggling.
    return <CbTooltip content="Notifications for this user will be enabled when the team assignment is saved.">
        <button type="button" style={{
        cursor: 'default'
      }}>
          <ICON_BY_NAME.alarmbell width="15px" height="15px" color="cloud.500" />
        </button>
      </CbTooltip>;
  }
};